import LineOutput from './LineOutput';
import kebabCase  from '../../../../../Lib/helpers/kebabCase';

export default class PhpLine extends LineOutput {

    output() {
        return `'${kebabCase(this.subject.name)}' => '${this.decorator.output()}',`
    }

}